import daily from './daily';
import monthly from './monthly';
import summary from './summary';

export default { daily, monthly, summary };
